module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "jm.f1dcfc6d.png" + "?" + Date.now();